import { render, staticRenderFns } from "./OutOfFlowButton.vue?vue&type=template&id=6c0efe81&scoped=true&"
import script from "./OutOfFlowButton.vue?vue&type=script&lang=js&"
export * from "./OutOfFlowButton.vue?vue&type=script&lang=js&"
import style0 from "./OutOfFlowButton.vue?vue&type=style&index=0&id=6c0efe81&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0efe81",
  null
  
)

export default component.exports